<template>
   <v-col md="12" style="min-height: 93vh;">
    <v-row justify="center" align="center" style="max-width: 600px; margin: 0 auto; border: 1px solid #cccccc">
      <v-col>
        <v-row justify="center" style="margin: 0 auto;">
          <h1>Tu Pedido está en proceso</h1>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <img src="@/assets/alitas.jpg" style="max-height: 100px; max-width: 200px;" />
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" style="background-color: #cccccc; max-width: 600px; margin: 0 auto; border: 1px solid #cccccc" class="pb-0">
      <v-col class="pb-0">
        <v-row justify="center" style="margin: 0 auto;">
          <p>El pedido {{ num_order }} está en camino y será entregado por {{ delivery_man_name }}</p>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <img src="@/assets/repartidor.jpg" style="height: 90px; width: 90px; background: 50% 50% no-repeat;" />
        </v-row>
        <v-row justify="center" style="margin: 0 auto;" class="pb-0">
          <p>Identifícalo por el dispositivo</p>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" style="max-width: 600px; margin: 0 auto; border: 1px solid #cccccc">
      <v-col>
        <v-row justify="center" style="margin: 0 auto;">
          <strong>El pedido será entregado en:</strong>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <p>{{ order_place }}</p>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <strong>Hora estimada de entrega:</strong>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <p>{{ order_date }}</p>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <strong>Método de entrega:</strong>
        </v-row>
        <v-row justify="center" style="margin: 0 auto;">
          <p>{{ order_method }}</p>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  export default {
    name: 'OrderInProcess',

    data: () => ({
      num_order: '123',
      delivery_man_name: 'Pablo',
      order_place: 'Eje 4 Sur 1234 Int 6 Col. Letrán Valle',
      order_date: 'Martes 5 de Mayo 2020 a las 16:45Hrs',
      order_method: 'En la puerta de tu casa'
    })
  }
</script>

<style scoped>
  p{
    text-align: center;
    color: #555555;
  }
  h1{
    text-align: center;
    color: gray;
  }
</style>